export default __webpack_public_path__ + "static/media/most-popular.82b3af23.svg";